import { render, staticRenderFns } from "./AdminOfferHistory.vue?vue&type=template&id=01516d13&scoped=true&"
import script from "./AdminOfferHistory.vue?vue&type=script&lang=js&"
export * from "./AdminOfferHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01516d13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01516d13')) {
      api.createRecord('01516d13', component.options)
    } else {
      api.reload('01516d13', component.options)
    }
    module.hot.accept("./AdminOfferHistory.vue?vue&type=template&id=01516d13&scoped=true&", function () {
      api.rerender('01516d13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/AdminOfferHistory.vue"
export default component.exports